export default __webpack_public_path__ + "static/media/Group 47.ed3f47dd.png";